import { useEffect, useMemo } from "react";
import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { ShowAlert, showConfirmationDialog } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const cols: string[] = ["#", "Name", "Description", "Actions"];

const AllergenListing = observer(() => {
  const { allergenStore } = useStores();
  const { allergens, fetchAllergens, setEditAllergen, deleteAllergen } =
    allergenStore;

  useEffect(() => {
    fetchAllergens();
  }, []);

  const allergensList = useMemo(() => {
    return allergens;
  }, [allergens]);

  const handleDelete = (allergenId: number) => {
    showConfirmationDialog(() => {
      deleteAllergen(allergenId, (res: boolean) => {
        if (res) {
          ShowAlert.Success("Allergen deleted successfully.");
          fetchAllergens();
        } else ShowAlert.Error("Request failed. Please try again.");
      });
    });
  };

  return (
    <table className="table table-responsive table-striped shadow-lg">
      <thead>
        <tr>
          {cols.map((c, i) => (
            <th
              scope="col"
              className="border-top-0 border-start-0 border-end-0 border-3 border-warning"
              key={i}
            >
              {c}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {allergensList?.map((allergen, i) => {
          return (
            <tr key={i}>
              <th scope="row">{i + 1}</th>
              <td>{allergen.allergenName}</td>
              <td>{allergen.description}</td>

              <td>
                <div className="btn-group">
                  <button
                    className="btn"
                    onClick={() => setEditAllergen(allergen)}
                  >
                    <FontAwesomeIcon icon={faEdit} className="text-primary" />
                  </button>
                  <button
                    className="btn"
                    onClick={() => handleDelete(allergen.allergenId)}
                  >
                    <FontAwesomeIcon icon={faTrash} className="text-danger" />
                  </button>
                </div>
              </td>
            </tr>
          );
        })}
        {!allergensList?.length && (
          <tr>
            <th colSpan={5} className="text-center">
              No data available.
            </th>
          </tr>
        )}
      </tbody>
    </table>
  );
});

export default AllergenListing;
